var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.032,10.437h-8.833v3.525h5.057c-.227,1.157-.891,2.134-1.876,2.798-.844.563-1.915.907-3.181.907-2.447,0-4.518-1.649-5.26-3.877-.195-.563-.297-1.165-.297-1.79s.109-1.227.297-1.79c.742-2.228,2.814-3.877,5.26-3.877,1.384,0,2.619.477,3.596,1.407l2.673-2.673c-1.618-1.516-3.736-2.447-6.269-2.447-3.666,0-6.832,2.11-8.371,5.175-.641,1.266-1.008,2.689-1.008,4.205s.367,2.939,1.008,4.205c1.54,3.064,4.706,5.174,8.371,5.174,2.533,0,4.651-.844,6.198-2.275,1.766-1.634,2.783-4.041,2.783-6.894,0-.618-.055-1.204-.148-1.774Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/social-google.c19ffb99831472f9086d42cf7865f7f8.svg";
export { ForwardRef as ReactComponent };